import { render, staticRenderFns } from "./CampaingBox.vue?vue&type=template&id=34b79add&"
import script from "./CampaingBox.vue?vue&type=script&lang=js&"
export * from "./CampaingBox.vue?vue&type=script&lang=js&"
import style0 from "./CampaingBox.vue?vue&type=style&index=0&id=34b79add&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QIcon,QTooltip,QChip,QBtnToggle,QBtn,QSeparator,QTabPanels,QTabPanel,QTabs,QTab,QSkeleton} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QIcon,QTooltip,QChip,QBtnToggle,QBtn,QSeparator,QTabPanels,QTabPanel,QTabs,QTab,QSkeleton})
